import { adminPermissions, opportunityPermissions, permissions, rulesPermissions, PermissionsPolicy } from '@/auth';
import { Permission } from '@/models';
import { containsAllFrom } from '@/utils';
import { router } from '@/main';
import { VueConstructor } from 'vue';

export function flatPermissions(permissionsPolicy: PermissionsPolicy): Permission[] {
  return Object.values(permissionsPolicy).flat();
}

export default {

  install(Vue: VueConstructor) {
    Vue.prototype.$permissions = permissions;
    Vue.prototype.$adminPermissions = adminPermissions;
    Vue.prototype.$opportunityPermissions = opportunityPermissions;
    Vue.prototype.$rulesPermissions = rulesPermissions;

    Vue.prototype.$isAccessible = (routePermissions: Permission[]): boolean => {
      return containsAllFrom(routePermissions, router.app.$store.state.geek.current.permissions);
    };

    Vue.prototype.$isAccessibleByOneOfRule = (routePermissions: Permission[]): boolean => {
      return routePermissions.some((p: Permission) => router.app.$store.state.geek.current.permissions.includes(p));
    };

    Vue.prototype.$flatPermissions = flatPermissions;
  },

};
